/**
 * @generated SignedSource<<351bda6b7e729797da348a21022f28a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginProviderEnum = "AZURE_MULTI_TENANT" | "AZURE_SINGLE_TENANT" | "FACEBOOK" | "GITHUB" | "GOOGLE_MULTI_TENANT" | "INSTAGRAM" | "LINKEDIN" | "OAUTH2_GENERIC" | "PASSWORD" | "SITETOKEN";
export type Auth_LoginClients_Query$variables = Record<PropertyKey, never>;
export type Auth_LoginClients_Query$data = {
  readonly loginClients: ReadonlyArray<{
    readonly authorizationUrl: string | null | undefined;
    readonly clientId: string | null | undefined;
    readonly domains: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly isEnabled: boolean | null | undefined;
    readonly provider: LoginProviderEnum | null | undefined;
  } | null | undefined> | null | undefined;
};
export type Auth_LoginClients_Query = {
  response: Auth_LoginClients_Query$data;
  variables: Auth_LoginClients_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LoginClient",
    "kind": "LinkedField",
    "name": "loginClients",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authorizationUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "domains",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Auth_LoginClients_Query",
    "selections": (v0/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Auth_LoginClients_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5796079e9c4c96d6a30f2d1dc38e1476",
    "id": null,
    "metadata": {},
    "name": "Auth_LoginClients_Query",
    "operationKind": "query",
    "text": "query Auth_LoginClients_Query {\n  loginClients {\n    authorizationUrl\n    clientId\n    provider\n    isEnabled\n    domains\n  }\n}\n"
  }
};
})();

(node as any).hash = "0f0a7b06edb71501ff1b1d1eb4a9069e";

export default node;
